import { FunctionComponent, HTMLAttributes, ReactNode } from 'react'
import { Theme } from '@emotion/react'
import styled from '@emotion/styled'
import { buildAssetsPath } from '@/libs/helpers/assets'

interface ToolTipProps extends HTMLAttributes<HTMLDivElement> {
  /** Changes input style to error color */
  tooltipContent?: ReactNode
}

const StyledToolTipContent = styled.span``

const StyledToolTipContainer = styled.div<ToolTipProps>`
  position: relative;
  display: inline-block;
  ${StyledToolTipContent} {
    visibility: hidden;
    background-color: black;
    color: #fff;
    text-align: center;
    padding: 5px;
    border-radius: 6px;
    width: auto;
    bottom: 115%;
    left: 50%;
    margin-left: -85px;
    position: absolute;
    z-index: 1;
  }
  &:hover ${StyledToolTipContent} {
    visibility: visible;
  }
  ${StyledToolTipContent}::after {
    content: ' ';
    position: absolute;
    top: 100%; /* At the bottom of the tooltip */
    right: 20%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
  }
`

// We need to export components that way so the the props documentation is generated automatically
const ToolTip: FunctionComponent<ToolTipProps> = ({ tooltipContent, children, ...props }) => {
  return (
    <StyledToolTipContainer {...props}>
      {children}
      <StyledToolTipContent>{tooltipContent}</StyledToolTipContent>
    </StyledToolTipContainer>
  )
}

export enum CardBrands {
  VISA = 'visa',
  MASTERCARD = 'mastercard',
  AMEX = 'amex',
  DISCOVER = 'discover',
}

export interface SupportedCardBrands extends HTMLAttributes<HTMLDivElement> {
  brands: CardBrands[]
  theme: Theme
}

const SupportedCardBrands: FunctionComponent<SupportedCardBrands> = ({ brands, theme }) => {
  const brandImages = brands.map((brand: CardBrands) => {
    return (
      <img
        key={brand}
        src={buildAssetsPath(`/images/cards/${brand}.png`)}
        alt={brand}
        style={{ width: 50 }}
      />
    )
  })

  const isMobile = window.innerWidth < 700

  return (
    <div style={{ display: 'flex', gap: 5 }}>
      {brandImages.slice(0, isMobile ? 2 : undefined)}
      {brandImages.length > 2 && isMobile && (
        <ToolTip
          tooltipContent={<div style={{ display: 'flex', gap: 5 }}>{brandImages.slice(2)}</div>}
        >
          <div
            style={{
              color: theme.palette.PRIMARY,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid #c8c7c9',
              borderRadius: 6,
              height: 30,
              width: 25,
            }}
          >
            +{brandImages.length - 2}
          </div>
        </ToolTip>
      )}
    </div>
  )
}

export default SupportedCardBrands
